export default "__VITE_ASSET__ac562946__"